// src/components/desktop/DesktopApp.jsx
import { useState, useEffect } from "react";
import SeoTags from "../../../seo/SeoTags";

import LeftRail from "../left-rail/LeftRail";
import { useLang } from "../../../i18n/LangContext";

import DesktopHero from "./hero/DesktopHero";
import speaker from "../../../assets/desktopAdvertise/hero/speaker.png";
import HeroAnimation from "./hero/HeroAnimation";
import DesktopAdvantages from "./advantages/DesktopAdvantages";
import DesktopRewarded from "./rewarded/DesktopRewarded";
import DesktopTrafficTypes from "./traffic/DesktopTrafficTypes";
import DesktopSelfServe from "./selfServe/DesktopSelfServe";

import DesktopFooter from "../footer/DesktopFooter";
import GlobeFx from "../../../assets/footer/globe.png";
import GlobeBase from "../../../assets/footer/globe 1.png";
import LogoPNG from "../../../assets/footer/logo-footer.png";
import ContactFormGlass from "../../common/contact/ContactFormGlass";

import "./DesktopAppAdvertise.css";

export default function DesktopAppAdvertise({ onGetStarted = () => {}, onContact = () => {} }) {
  const { lang, t } = useLang();
  const isBG = lang === "bg";

  // 🔹 Overlay loader (над всичко)
  const [showOverlay, setShowOverlay] = useState(true);
  const [fadeOut, setFadeOut] = useState(false);

  useEffect(() => {
    // Дай време да се заредят шрифтове/стили отдолу
    const t1 = setTimeout(() => setFadeOut(true), 1000);   // започва fade
    const t2 = setTimeout(() => setShowOverlay(false), 1200); // маха overlay-а след анимацията
    return () => { clearTimeout(t1); clearTimeout(t2); };
  }, []);

  const base = "https://offerwall-web-9dd25471534d.herokuapp.com";
  const url = base;
  const canonical = url;
  const locale = isBG ? "bg_BG" : "en_US";

  const title = isBG
    ? "Givvy Offerwall — Реклама с премиум трафик"
    : "Givvy Offerwall — Advertise With Premium Offerwall Traffic";

  const description = isBG
    ? "Достигни аудитории по света чрез проверен офервол, собствен анти-фрод и прецизен таргетинг."
    : "Reach global audiences through a curated offerwall, proprietary fraud protection, and precise targeting.";

  const alternates = [{ href: `${base}`, hreflang: "x-default" }];

  const jsonLd = [
    {
      "@context": "https://schema.org",
      "@type": "Organization",
      "name": "Givvy Offerwall",
      "url": base,
      "logo": `${base}/og/logo.png`,
      "sameAs": []
    },
    {
      "@context": "https://schema.org",
      "@type": "WebApplication",
      "name": "Givvy Offerwall",
      "applicationCategory": "BusinessApplication",
      "offers": { "@type": "Offer", "price": "0", "priceCurrency": "USD" },
      "aggregateRating": { "@type": "AggregateRating", "ratingValue": "4.8", "ratingCount": "1243" },
      "url": base,
      "image": `${base}/og/og-hero.jpg`,
      "installUrl": [
        "https://play.google.com/store/apps/details?id=com.aura",
        "https://apps.apple.com/app/id000000"
      ]
    },
    {
      "@context": "https://schema.org",
      "@type": "WebSite",
      "name": "Givvy Offerwall",
      "url": base,
      "inLanguage": isBG ? "bg-BG" : "en-US",
      "potentialAction": {
        "@type": "SearchAction",
        "target": `${base}/search?q={query}`,
        "query-input": "required name=query"
      }
    }
  ];

  const sections = [
    { id: "home", label: t.nav.home },
    { id: "advertise", label: t.nav.advertise },
    { id: "monetize", label: t.nav.monetize },
    { id: "faq", label: t.nav.faq },
    { id: "about", label: t.nav.about },
    { id: "contact", label: t.nav.contact ?? "Contact" },
  ];

  return (
    <>
      <SeoTags
        title={title}
        description={description}
        url={url}
        canonical={canonical}
        locale={locale}
        alternates={alternates}
        image={`${base}/og/og-hero.jpg`}
        jsonLd={jsonLd}
      />

      {/* Съдържанието се рендва нормално отдолу */}

      <LeftRail
        sections={sections}
        railLeft={100}
        navHeight={88}
        dotSize={16}
        dotsSide="left"
        dotsGap={54}
        dotsVAlign="center"
      />

      <div className="desktop-advertise-area">
        <DesktopHero
          id="home"
          speaker={speaker}
          onGetStarted={onGetStarted}
          onContact={onContact}
        />

        <DesktopAdvantages id="advertise" />

        <DesktopRewarded id="monetize" />

        <DesktopTrafficTypes id="faq" />

        <DesktopSelfServe id="about" />

        <ContactFormGlass
          id="contact"
          eyebrow={t.contactForm.eyebrow}
          titleLine1={t.contactForm.titleLine1}
          titleLine2={t.contactForm.titleLine2}
          fields={t.contactForm.fields}
          roleOptions={t.contactForm.roleOptions}
          submitLabel={t.contactForm.submit}
        />



        <DesktopFooter
          logoSrc={LogoPNG}
          globeSrc={GlobeBase}
          globeOverlaySrc={GlobeFx}   // <-- тук подаваме overlay-a
          socialLinks={[
            "https://facebook.com/…",
            "https://instagram.com/…",
            "https://youtube.com/…",
            "https://t.me/…",
            "https://x.com/…",
            "https://tiktok.com/@…",
          ]}
        />
      </div>

    </>
  );
}
